import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";

export default function RoleBaseModel({ setModal }) {
  const path = "Assets/scss/postproject.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  return (
    <div>
      <button onClick={() => setModal(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Please Join As Company / Expert</h4>
        <p>
          Please complete your Profile to create posts and access exclusive
          features.
        </p>
      </ModalBody>
      {/* <h1 className="btn">Join As Company / Expert</h1> */}
      <br></br>
      <div className="modal-footer" style={{ display: "flex" , flexWrap:'nowrap',columnGap:'30px' }}>
        <button
          className="btn"
          onClick={() => {
            setModal((state) => !state);
            navigate(`/${lan}/registration`, {
              state: { joinasa: "expert", type: 1 },
            });
          }}
        >
          Join As Expert
        </button>
        <button
          className="btn"
          onClick={() => {
            setModal((state) => !state);
            navigate(`/${lan}/registration`, {
              state: { joinasa: "company", type: 2 },
            });
          }}
        >
          Join As Company
        </button>
      </div>
    </div>
  );
}
